import React from "react";
import { NavLink } from "react-router-dom";
import { IoCloseSharp } from "react-icons/io5";
import Nav from "../../../constants/nav";
import { ILoginUser } from "../../../store/@types/auth";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  user: ILoginUser | null;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose, user }) => {
  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300 z-40 lg:hidden
          ${isOpen ? "opacity-100 visible" : "opacity-0 invisible"}`}
        onClick={onClose}
      />

      {/* Slide-in Menu Panel */}
      <div
        className={`flex flex-col fixed top-0 right-0 bottom-0 w-80 bg-white shadow-2xl z-[999] lg:hidden transform transition-transform duration-300 ease-in-out
          ${isOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        {/* Menu Header */}
        <div className="flex items-center justify-between p-4 ">
          <h2 className="text-lg font-semibold text-white">Menu</h2>
          <button
            onClick={onClose}
            className="px-6 py-2 bg-primary-500 hover:scale-105 transition-transform rounded-full"
            aria-label="Close menu"
          >
            <IoCloseSharp size={32} className="text-white" />
          </button>
        </div>

        {/* Menu Items */}
        <nav className="flex-1 overflow-y-auto py-4">
          <div className="px-3 space-y-1">
            {Nav.map((item) => (
              <NavLink
                key={item.title}
                to={item.link}
                onClick={onClose}
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 rounded-lg text-2xl font-semibold transition-all duration-200
                  ${
                    isActive
                      ? "text-primary-700"
                      : "text-gray-700 hover:bg-gray-50/10"
                  }`
                }
              >
                <span>{item.title}</span>
              </NavLink>
            ))}
          </div>
        </nav>

        {/* Footer (if not logged in) */}
        {!user && (
          <div className="p-4 border-t border-gray-100/20 mt-auto">
            <div className="grid grid-cols-2 gap-2">
              <NavLink
                to="/login"
                onClick={onClose}
                className="block w-full text-center py-3 bg-primary-500 text-white rounded-xl hover:bg-primary-600 transition-colors"
              >
                Login
              </NavLink>
              <NavLink
                to="/register"
                onClick={onClose}
                className="block w-full text-center py-3 bg-white text-primary-600 border-2 border-primary-500 rounded-xl hover:bg-primary-50 transition-colors"
              >
                Sign Up
              </NavLink>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MobileMenu;
